import { render, staticRenderFns } from "./SavingContent.vue?vue&type=template&id=7701b1b2&scoped=true&"
import script from "./SavingContent.vue?vue&type=script&lang=js&"
export * from "./SavingContent.vue?vue&type=script&lang=js&"
import style0 from "./SavingContent.vue?vue&type=style&index=0&id=7701b1b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7701b1b2",
  null
  
)

export default component.exports